import { apiSlice } from "../apiSlice";

const CONTACT_URL = "/api/v1/contact";

export const contactApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    createContact: builder.mutation({
      query: ({ data }) => ({
        url: `${CONTACT_URL}`,
        method: "POST",
        body: data,
      }),
    }),
  }),
});

export const { useCreateContactMutation } = contactApiSlice;
